import { render, staticRenderFns } from "./indnex.vue?vue&type=template&id=ed6e6262&scoped=true"
import script from "./indnex.vue?vue&type=script&lang=js"
export * from "./indnex.vue?vue&type=script&lang=js"
import style0 from "./indnex.vue?vue&type=style&index=0&id=ed6e6262&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6e6262",
  null
  
)

export default component.exports